var tooltipOptions = {
  container : 'body',
  html : true
}

document.addEventListener("turbo:before-cache", function() {
  document.querySelectorAll('.with-tooltip, form abbr[title]').forEach(function(element) {
    const tooltip = bootstrap.Tooltip.getInstance(element);
    if (tooltip) {
      tooltip.hide();
    }
  });
});

document.addEventListener('initialize', function() {
  document.querySelectorAll('.with-tooltip, form abbr[title]').forEach(function(element) {
    if (element.dataset.title && !element.getAttribute('title')) {
      element.setAttribute('title', element.dataset.title)
    }

    new bootstrap.Tooltip(element, {
      container: 'body',
      html: true
    });
  });
});
